import { Typography } from '@mui/material';

export function TextHeader({ title }) {
  return (
    <Typography variant="h6" sx={{ flexGrow: 1 }}>
      {title}
    </Typography>
  );
}
